import { REDIRECT_DS_ADS_LINK } from './constants';

export function removeDsAdsRouteLink() {
  window.open(REDIRECT_DS_ADS_LINK.COMMON_REDIRECTION_LINK, '_blank');
}
